import { learningPath } from './learningPath'
import { profiles } from './profiles'
import { webinars } from './webinars'

export const slices = {
  learningPath,
  profiles,
  webinars,
}
